// src/components/directory/DirectoryFooter.jsx
// Covers: SU-01 (non-profit / built-by-Veterans identity)

import React from 'react';
import styles from './DirectoryFooter.module.css';

export default function DirectoryFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>

        <div className={styles.top}>
          <div className={styles.brand}>
            <div className={styles.logoRow}>
              <span className={styles.logoMark}>◉</span>
              <span className={styles.logoName}>
                Signal<span className={styles.logoAccent}>Post</span>
              </span>
            </div>
            <p className={styles.tagline}>
              Canada's independent Veteran & family resource directory.<br />
              Free to use. No account needed. No advertising.
            </p>
            {/* SU-01 badges */}
            <div className={styles.badges}>
              <span className={styles.badge}>🎖 Built by Veterans</span>
              <span className={styles.badge}>🤝 Non-profit</span>
              <span className={styles.badge}>🇨🇦 Canadian</span>
              <span className={styles.badge}>🔒 No data collected</span>
            </div>
          </div>

          <div className={styles.links}>
            <a href="#how-we-verify">How we verify programs</a>
            <a href="#submit">Submit a program</a>
            <a href="#flag">Flag an outdated listing</a>
            <a href="#about">About Signal Post</a>
            <a href="#privacy">Privacy policy</a>
            <a href="#contact">Contact us</a>
          </div>
        </div>

        <div className={styles.bottom}>
          Signal Post is an independent directory. Not affiliated with Veterans Affairs Canada or the Department of National Defence.
          Always confirm program details directly with the provider before accessing services.{' '}
          
        </div>

      </div>
    </footer>
  );
}
